export default {
    // 텍스트 패널
    '文本': '텍스트',
    '颜色': '색상',
    '字体': '글꼴',
    '大写': '대문자',
    '字号': '글꼴 크기',
    '背景色': '배경색',
    '圆角': '모서리 둥글기',
    '内边距': '여백',
    '描边': '테두리',
    '对齐': '정렬',
    '底边距': '하단 여백',
    '紧贴底边': '하단 정렬',
    '垂直居中': '세로 중앙',

    // 기본 패널
    '基础': '기본',
    '位置': '위치',
    '尺寸': '크기',
    '旋转': '회전',
    '居中': '중앙',
    '原始尺寸': '원본 크기',
    '平铺': '타일',
    '拉伸': '늘이기',
    '透明度': '투명도',
    '视频尺寸为{width}x{height}。': '비디오 크기는 {width}x{height}입니다.',
    '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': '텍스트 크기를 조정하면 텍스트 표시가 변경될 수 있으므로 글꼴 크기를 조정하는 것을 권장합니다',

    // 라이브러리
    '视频': '비디오',
    '音频': '오디오',
    '图片': '이미지',
    '转场': '전환',
    '转场效果': '전환 효과',
    '点击应用': '클릭하여 적용',
    '新建文本': '새 텍스트',
    '花字库': '폰트 라이브러리',
    '默认文本': '기본 텍스트',

    // 내보내기
    '导出': '내보내기',
    '프로젝트 불러오기': '프로젝트 불러오기',

    // 도구
    '撤销': '실행 취소',
    '重做': '다시 실행',

    // 툴팁
    '清除选中': '선택 해제',
    '删除当前选中': '선택 항목 삭제',
    '分割当前选中': '선택 항목 분할',
    '分割当前选中，只保留左侧': '선택 항목 분할, 왼쪽만 유지',
    '分割当前选中，只保留右侧': '선택 항목 분할, 오른쪽만 유지',
    '水平翻转': '좌우 반전',
    '将连续且相邻的素材拼接后下载': '연속된 인접 소재 결합 후 다운로드',

    // 라이브러리
    '当前': '현재',
    '导入': '가져오기',
    '全部': '전체',
    '删除': '삭제',
    '拖拽视频到这里': '여기에 비디오를 드래그하세요',
    '拖拽音频到这里': '여기에 오디오를 드래그하세요',
    '拖拽图片到这里': '여기에 이미지를 드래그하세요',
    '或者点击上传': '또는 클릭하여 업로드',
    '暂无素材，请先导入素材': '소재가 없습니다. 먼저 소재를 가져오세요',

    // 관리자
    '选择一个视频，开始你的创作。': '비디오를 선택하고 창작을 시작하세요.',

    // 애니메이션 패널
    '动画': '애니메이션',
    '入场动画': '등장 애니메이션',
    '出场动画': '퇴장 애니메이션',
    '关键帧动画': '키프레임 애니메이션',
    '选择动画效果': '애니메이션 효과 선택',
    '添加': '추가',
    '确定删除此动画？': '이 애니메이션을 삭제하시겠습니까?',
    '持续时间': '지속 시간',
    '秒': '초',
    '起始时间': '시작 시간',
    '结束时间': '종료 시간',
    '暂无动画，请添加动画效果': '애니메이션이 없습니다. 애니메이션 효과를 추가하세요',

    // 애니메이션 프리셋
    '淡入': '페이드 인',
    '从左滑入': '왼쪽에서 슬라이드 인',
    '从右滑入': '오른쪽에서 슬라이드 인',
    '从上滑入': '위에서 슬라이드 인',
    '从下滑入': '아래에서 슬라이드 인',
    '放大进入': '확대 입장',
    '旋转进入': '회전 입장',
    '淡出': '페이드 아웃',
    '向左滑出': '왼쪽으로 슬라이드 아웃',
    '向右滑出': '오른쪽으로 슬라이드 아웃',
    '向上滑出': '위로 슬라이드 아웃',
    '向下滑出': '아래로 슬라이드 아웃',
    '缩小退出': '축소 퇴장',
    '旋转退出': '회전 퇴장',
    '脉冲': '맥박',
    '抖动': '흔들기',
    '弹跳': '바운스',
    '摆动': '스윙',
    '闪烁': '깜빡임',
    '自定义': '사용자 정의',
    '起始状态': '시작 상태',
    '结束状态': '종료 상태',
    '位置 X': '위치 X',
    '位置 Y': '위치 Y',
    '缩放': '크기 조절',
    '旋转角度': '회전 각도',
    '不透明度': '불투명도',

    // 필터 패널
    '可用滤镜': '사용 가능한 필터',
    '滤镜参数': '필터 매개변수',
    '选择滤镜': '필터 선택',
    '请选择要编辑的滤镜': '편집할 필터를 선택하세요',
    '强度': '강도',
    '请选择一个滤镜以调节参数': '매개변수를 조정할 필터를 선택하세요',
    '灰度': '그레이스케일',
    '模糊': '흐림',
    '亮度': '밝기',
    '对比度': '대비',
    '饱和度': '채도',

    '无': '없음',
    '入场': '입장',
    '出场': '퇴장',
    '动效': '애니메이션',
    '结束位置': '종료 위치',
    '使用当前时间轴上的当前时间点': '타임라인의 현재 시간 사용',
    '开始位置': '시작 위치',
    '当前有动画，调整可能不能直接看到效果，请播放片段查看': '현재 애니메이션이 있습니다. 조정 효과를 바로 볼 수 없을 수 있으므로 세그먼트를 재생하여 확인하세요',
    '滤镜': '필터',
    '恢复正在编辑的数据': '편집 중인 데이터 복원',
    '仅支持视频和图片': '비디오와 이미지만 지원',
    '删除转场': '전환 삭제',
    '已经存在视频转场，请先删除': '비디오 전환이 이미 존재합니다. 먼저 삭제하세요',
    '当前片段是轨道最后一个片段，不能应用转场效果': '현재 세그먼트가 트랙의 마지막입니다. 전환 효과를 적용할 수 없습니다',
    '暂无转场效果': '사용 가능한 전환 효과 없음',
    '片段不存在': '세그먼트가 존재하지 않습니다',
    '请先选择一个片段': '먼저 세그먼트를 선택하세요',
    '轨道不存在': '트랙이 존재하지 않습니다',
    '默认': '기본',

    // 전환 효과
    '淡入淡出': '페이드',
    '滑动': '슬라이드',
    '百叶窗': '블라인드',
    '溶解': '디졸브',

    // 비디오/오디오 패널
    '音量': '볼륨',
    '请先选择视频片段': '먼저 비디오 세그먼트를 선택하세요',
    '请先选择音频片段': '먼저 오디오 세그먼트를 선택하세요',
    '重置': '재설정',

    // 고급 내보내기
    '高级导出': '설정',
    '取消': '취소',
    '正在导出...': '내보내는 중...',
    '导出完成！': '내보내기 완료!',
    '导出失败：': '내보내기 실패: ',
    '导出类型': '내보내기 유형',
    '输出格式': '출력 형식',
    '分辨率': '해상도',
    '帧率': 'FPS',
    '视频比特率': '비디오 비트레이트',
    '编码格式': '코덱',
    '包含音频': '오디오 포함',
    '关闭时将导出无声音的视频': '비활성화 시 소리 없는 비디오가 내보내집니다',
    '音频比特率': '오디오 비트레이트',
    '比特率': '비트레이트',
    '采样率': '샘플링 레이트',
    '导出中...': '내보내는 중...',
    '开始导出': '내보내기 시작',
};
